import * as React from 'react';
import { connect } from 'react-redux';

import { State as AccessTokenState } from '~/AccessToken';
import { Link } from '~/UI/Button';

import styles from './styles.less';

interface Props {
	isLoggedIn: boolean;
}

const Logo = ({ isLoggedIn }: Props) => {
	const logoTarget = isLoggedIn ? '/' : '/login';

	return (
		<h1 className={styles.logo}>
			<Link styles={styles} to={logoTarget}>
				<strong className={styles.logoTitle}>Price Monitor</strong>
				<span className={styles.logoSubTitle}>COGVIO</span>
			</Link>
		</h1>
	);
};

function mapStateToProps({ accessToken }: { accessToken: AccessTokenState }): { isLoggedIn: boolean } {
	return {
		isLoggedIn: accessToken.accessToken !== null,
	};
}

export default connect(mapStateToProps)(React.memo(Logo));
